module.exports = __webpack_public_path__ + "static/media/testimonials-karine.f429f1bb.png";